import React from 'react';
import { toast } from 'react-toastify';
import { Icon } from '@scuf/common';

import 'react-toastify/dist/ReactToastify.css';
import './toasts.scss';

class Toasts {
  iconWithText = (AnyIcon: React.ReactNode, message: string) => {
    return (
      <div className="toast-body-text-and-icon-container">
        <div className="pretext-icon">{AnyIcon}</div>
        <div>{message}</div>
      </div>
    );
  };

  public success(message: string) {
    toast(
      this.iconWithText(<Icon root="common" name="badge-check" />, message),
      {
        // Shorter close time for success, as per HUE request
        autoClose: 5000,
        type: toast.TYPE.SUCCESS
      }
    );
  }
  public error(message: string) {
    toast(
      this.iconWithText(
        <Icon root="common" name="badge-warning" />,
        message
      ),
      {
        type: toast.TYPE.ERROR
      }
    );
  }

  public warn(message: string) {
    toast(
      this.iconWithText(<Icon root="common" name="badge-info" />, message),
      {
        type: toast.TYPE.WARNING
      }
    );
  }
  public info(message: string, autoClose: any = 0) {
    toast(
      this.iconWithText(<Icon root="common" name="badge-info" />, message),
      {
        autoClose: autoClose,
        type: toast.TYPE.INFO
      }
    );
  }
  public dismiss() {
    toast.dismiss();
  }

}
export default new Toasts();
